import { useSearchParams } from "react-router";
import { useState } from "react";
import { RoomCreateOrUpdateUsersResponse } from "@api/src/types/responses";
import useUser from "@app/zustand/user";
import useMedspotStore from "@app/zustand/store";
import { refreshUser } from "@app/utils/use-most-fresh-user";

export default function ButtonLeaveGroup() {
  const [searchParams] = useSearchParams();
  const [isProcessing, setIsProcessing] = useState(false);
  const setIsDrawerOpen = useMedspotStore((state) => state.setDrawerOpen);

  const me = useUser((state) => state.user!);

  const qRoomId = searchParams.get("qRoomId");
  // const qRoomType = searchParams.get("qRoomType");
  // const isDirectMessageWithTwoUsers = qRoomType === RoomType.DIRECT && isInTheRoom && numberOfUsersInTheRoom === 2;

  const handleAction = async () => {
    if (!window.confirm("Voulez-vous vraiment quitter ce groupe ?")) {
      return;
    }
    setIsProcessing(true);
    try {
      fetch(`${import.meta.env.VITE_API_URL}/room`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: me.id,
          roomId: qRoomId,
          action: "remove-user",
        }),
      })
        .then((response) => response.json() as Promise<RoomCreateOrUpdateUsersResponse>)
        .then((response) => {
          if (response?.error) {
            alert(response.error);
          } else {
            refreshUser("button-leave-group");
            setIsDrawerOpen(true);
          }
        });
      // Optionally handle success (redirect or state update)
    } catch (error) {
      console.error("Error processing action:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <button
      onClick={handleAction}
      // disabled={isProcessing || isDirectMessageWithTwoUsers}
      disabled={isProcessing}
      className="w-max cursor-pointer py-1 text-xs text-sky-900"
      type="button"
    >
      Quitter le groupe
    </button>
  );
}
